import Link from "next/link";
import React, { FC } from "react";
import cls from "./customBlocks.module.scss";
import { TranslationsType } from "../../../../types/homePageTypes";
import Specialists from "../../Specialists/Specialists";

interface IProps {
    dbName: string;
    pageSlug: string;
    translationsData: TranslationsType;
}

const CustomBlocks: FC<IProps> = ({ dbName, pageSlug, translationsData }) => {

    const renderBlocks = (blocksContent: { title: string, content: string, path: string}[], parentClassName: string) => (
        <div className="container">
            <div className={cls[parentClassName]}>
                {blocksContent.map(({ title, content, path }, index) => {
                    const blockClass = index % 2 === 0 ? cls.evenBlock : cls.oddBlock;
                    return (
                        <div key={index} className={`${cls["blocks"]} ${blockClass}`}>
                            {pageSlug === 'accounting-services' && <span className={cls.block_number}>{'0' + (index + 1)}</span>}
                            <div className={cls.block_content}>
                                <span className={cls.block_title}>{title}</span>
                                <span className={cls.block_text}>{content}</span>
                            </div>
                            {pageSlug === "information" &&
                                <Link href={path}>
                                    <a>{translationsData.SeeMore}</a>
                                </Link>
                            }
                        </div>
                    );
                })}
            </div>
        </div>
    );

    let renderedContent: JSX.Element | null;

    switch (pageSlug) {
        case "information":
            const infoBlocksContent = [
                { title: translationsData.InformationBlock1Title, content: translationsData.InformationBlock1Content, path: 'laws-and-standards' },
                { title: translationsData.InformationBlock2Title, content: translationsData.InformationBlock2Content, path: 'reports' },
                { title: translationsData.InformationBlock3Title, content: translationsData.InformationBlock3Content, path: 'articles' },
                { title: translationsData.InformationBlock4Title, content: translationsData.InformationBlock4Content, path: 'links' }
            ];
            renderedContent = renderBlocks(infoBlocksContent, "infoBlocksContent");
            break;

        case "accounting-services":
            const accountingBlocksContent = [
                { title: translationsData.AccAndServicesBlock1Title, content: translationsData.AccAndServicesBlock1Content, path: '' },
                { title: translationsData.AccAndServicesBlock2Title, content: translationsData.AccAndServicesBlock2Content, path: '' },
                { title: translationsData.AccAndServicesBlock3Title, content: translationsData.AccAndServicesBlock3Content, path: '' },
                { title: translationsData.AccAndServicesBlock4Title, content: translationsData.AccAndServicesBlock4Content, path: '' },
                { title: translationsData.AccAndServicesBlock5Title, content: translationsData.AccAndServicesBlock5Content, path: '' }
            ];
            renderedContent = renderBlocks(accountingBlocksContent, "accountingBlocksContent");
            break;

        case "about-us":
            renderedContent = <Specialists dbName={dbName} translationsData={translationsData}/>
            break;

        default:
            renderedContent = null;
            break;
    }

    return renderedContent;
};

export default CustomBlocks;
